import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function CtaSection() {
  return <section id="contacto" className="py-24 relative z-10 overflow-hidden" data-id="element-14">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-brand-blue/10 pointer-events-none" data-id="element-15"></div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="glass-panel rounded-3xl p-10 md:p-20 text-center border border-brand-cyan/20 relative overflow-hidden" data-id="element-17">
          {/* Decorative elements */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-cyan via-brand-blue to-brand-cyan" data-id="element-18"></div>
          <div className="absolute -top-24 -right-24 w-48 h-48 bg-brand-cyan/20 rounded-full blur-3xl" data-id="element-19"></div>
          <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-brand-blue/20 rounded-full blur-3xl" data-id="element-20"></div>

          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 tracking-tight relative z-10" data-id="element-21">
            ¿Listo para escalar tu <br className="hidden md:block" data-id="element-22" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-cyan to-brand-blue" data-id="element-23">
              negocio al siguiente nivel?
            </span>
          </h2>

          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto relative z-10" data-id="element-24">
            Agenda una consultoría gratuita y descubre cómo nuestra tecnología
            puede transformar tus resultados en tiempo récord.
          </p>

          <div className="relative z-10 flex flex-col sm:flex-row justify-center items-center gap-4" data-id="element-25">
            <button className="w-full sm:w-auto px-8 py-4 rounded-lg bg-white text-brand-black font-bold text-lg hover:bg-gray-100 transition-colors flex items-center justify-center gap-2 group" data-id="element-26">
              Contactar ahora
              <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-27" />
            </button>
            <span className="text-sm text-gray-400" data-id="element-28">
              Cupos limitados para nuevos proyectos este mes.
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}